export default {
  beforeRouteEnter(to, from, next) {
    next(vm => vm.load());
  },
  beforeRouteUpdate(to, from, next) {
    next(vm => vm.load());
  },
};
